export const notificationConstants = {
  NOTIFICATION_LIST_LOADING: 'NOTIFICATION_LIST_LOADING',
  NOTIFICATION_LIST_SUCCESS: 'NOTIFICATION_LIST_SUCCESS',
  NOTIFICATION_LIST_FAILURE: 'NOTIFICATION_LIST_FAILURE',

  NOTIFICATION_EDIT_LOADING: 'NOTIFICATION_EDIT_LOADING',
  NOTIFICATION_EDIT_SUCCESS: 'NOTIFICATION_EDIT_SUCCESS',
  NOTIFICATION_EDIT_FAILURE: 'NOTIFICATION_EDIT_FAILURE',

  NOTIFICATION_DELETE_LOADING: 'NOTIFICATION_DELETE_LOADING',
  NOTIFICATION_DELETE_SUCCESS: 'NOTIFICATION_DELETE_SUCCESS',
  NOTIFICATION_DELETE_FAILURE: 'NOTIFICATION_DELETE_FAILURE'
};
